// // component
// import SvgColor from '../../../components/svg-color';

// // ----------------------------------------------------------------------

// const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

// const navConfig = [
//   {
//     title: 'dashboard',
//     path: '/dashboard/app',
//     icon: icon('ic_analytics'),
//   }, 
//   {
//     title: 'Order',
//     path: '/dashboard/orders',
//     icon: icon('ic_analytics'),
//   },
//   {
//     title: 'user',
//     path: '/dashboard/user',
//     icon: icon('ic_user'),
//   },
//   {
//     title: 'product',
//     path: '/dashboard/products',
//     icon: icon('ic_cart'),
//   },
//   {
//     title: 'category',
//     path: '/dashboard/category',
//     icon: icon('ic_cart'),
//   },
//   {
//     title: 'blog',
//     path: '/dashboard/blog',
//     icon: icon('ic_blog'), 
//   },
//   {
//     title: 'add product',
//     path: '/dashboard/add-product',
//     icon: icon('ic_blog'),
//   },
//   {
//     title: 'coupon code',
//     path: '/dashboard/coupon-code',
//     icon: icon('ic_blog'),
//   },
//   {
//     title: 'Settings',
//     path: '/dashboard/Settings',
//     icon: icon('ic_blog'),
//   },
//   {
//     title: 'Static Pages',
//     path: '/dashboard/StaticPageCreate',
//     icon: icon('ic_blog'),
//   },
//   {
//     title: 'NewsLetter',
//     path: '/dashboard/NewsLetter',
//     icon: icon('ic_blog'),
//   },
//   {
//     title: 'BulkMailing',
//     path: '/dashboard/BulkMailing',
//     icon: icon('ic_blog'),
//   },
//   // {
//   //   title: 'add category',
//   //   path: '/dashboard/add-category',
//   //   icon: icon('ic_blog'),
//   // },
//   // {
//   //   title: 'login',
//   //   path: '/login',
//   //   icon: icon('ic_lock'),
//   // },
//   // {
//   //   title: 'Not found',
//   //   path: '/404',
//   //   icon: icon('ic_disabled'),
//   // },
// ];

// export default navConfig;














// import DashboardIcon from '@mui/icons-material/Dashboard';
// import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
// import PeopleIcon from '@mui/icons-material/People';
// import InventoryIcon from '@mui/icons-material/Inventory';
// import CategoryIcon from '@mui/icons-material/Category';
// import ArticleIcon from '@mui/icons-material/Article';
// import AddBoxIcon from '@mui/icons-material/AddBox';
// import LocalOfferIcon from '@mui/icons-material/LocalOffer';
// import SettingsIcon from '@mui/icons-material/Settings';
// import WebIcon from '@mui/icons-material/Web';
// import EmailIcon from '@mui/icons-material/Email';
// import SendIcon from '@mui/icons-material/Send';

// // ----------------------------------------------------------------------

// const navConfig = [
//   {
//     title: 'dashboard',
//     path: '/dashboard/app',
//     icon: <DashboardIcon />,
//   },
//   {
//     title: 'Order',
//     path: '/dashboard/orders',
//     icon: <ShoppingCartIcon />,
//   },
//   {
//     title: 'user',
//     path: '/dashboard/user',
//     icon: <PeopleIcon />,
//   },
//   {
//     title: 'product',
//     path: '/dashboard/products',
//     icon: <InventoryIcon />,
//   },
//   {
//     title: 'category',
//     path: '/dashboard/category',
//     icon: <CategoryIcon />,
//   },
//   {
//     title: 'blog',
//     path: '/dashboard/blog',
//     icon: <ArticleIcon />,
//   },
//   {
//     title: 'add product',
//     path: '/dashboard/add-product',
//     icon: <AddBoxIcon />,
//   },
//   {
//     title: 'coupon code',
//     path: '/dashboard/coupon-code',
//     icon: <LocalOfferIcon />,
//   },
//   {
//     title: 'Settings',
//     path: '/dashboard/Settings',
//     icon: <SettingsIcon />,
//   },
//   {
//     title: 'Static Pages',
//     path: '/dashboard/StaticPageCreate',
//     icon: <WebIcon />,
//   },
//   {
//     title: 'NewsLetter',
//     path: '/dashboard/NewsLetter',
//     icon: <EmailIcon />,
//   },
//   {
//     title: 'BulkMailing',
//     path: '/dashboard/BulkMailing',
//     icon: <SendIcon />,
//   },
// ];

// export default navConfig;











import DashboardIcon from '@mui/icons-material/Dashboard';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import PeopleIcon from '@mui/icons-material/People';
import InventoryIcon from '@mui/icons-material/Inventory';
import CategoryIcon from '@mui/icons-material/Category';
import ArticleIcon from '@mui/icons-material/Article';
import AddBoxIcon from '@mui/icons-material/AddBox';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import SettingsIcon from '@mui/icons-material/Settings';
import WebIcon from '@mui/icons-material/Web';
import EmailIcon from '@mui/icons-material/Email';
import SendIcon from '@mui/icons-material/Send';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import ListAltIcon from '@mui/icons-material/ListAlt';
import WarehouseIcon from '@mui/icons-material/Warehouse'; // ✅ Inventory icon

const navConfig = [
  { title: 'Dashboard',    path: '/dashboard/app',         icon: <DashboardIcon /> },
  { title: 'Order',        path: '/dashboard/orders',      icon: <ShoppingCartIcon /> },
  { title: 'User',         path: '/dashboard/user',        icon: <PeopleIcon /> },
  {
    title: 'Products',
    icon: <InventoryIcon />, // ✅ Products ke liye InventoryIcon
    children: [
      { title: 'All Products', path: '/dashboard/products',    icon: <InventoryIcon /> },
      { title: 'Add Product',  path: '/dashboard/add-product', icon: <AddBoxIcon /> },
    ],
  },
  { title: 'Category',     path: '/dashboard/category',    icon: <CategoryIcon /> },
  { title: 'Blog',         path: '/dashboard/blog',        icon: <ArticleIcon /> },
  { title: 'Coupon Code',  path: '/dashboard/coupon-code', icon: <LocalOfferIcon /> },
  { title: 'Settings',     path: '/dashboard/Settings',    icon: <SettingsIcon /> },
  {
    title: 'Static Pages',
    icon: <WebIcon />,
    children: [
      { title: 'Add Page',  path: '/dashboard/StaticPageCreate', icon: <AddCircleOutlineIcon /> },
      { title: 'All Pages', path: '/dashboard/StaticPagesList',  icon: <ListAltIcon /> },
    ],
  },
  { title: 'NewsLetter',   path: '/dashboard/NewsLetter',  icon: <EmailIcon /> },
  { title: 'BulkMailing',  path: '/dashboard/BulkMailing', icon: <SendIcon /> },
  { title: 'Inventory',    path: '/dashboard/Inventory',   icon: <WarehouseIcon /> }, // ✅ Fixed
];

export default navConfig;